import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { FiniteCarouselBase } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/ByType/FiniteCarouselBase";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { SearchIconPillStyles } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/styles/SearchIconPillStyles";
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { localizedUrlWithQueryParams } from "@faire/retailer-visitor-shared/lib/pathUtils";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Search } from "@faire/web--source/slate/icons/foundation/Search";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import React from "react";
export var SearchIconPills = function() {
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, onItemClick = _React_useContext.onItemClick, requestId = _React_useContext.requestId, pageType = _React_useContext.pageType;
    var renderItem = function(item, index) {
        if (!item.query || !item.cta_link) {
            return null;
        }
        var pillLink = item.cta_link;
        var link = pageType === PAGE_TYPE.HOMEPAGE ? localizedUrlWithQueryParams(pillLink, {
            refType: ISearchRequestReferrer.SearchRequestReferrerType.HOMEPAGE_RECENT_SEARCHES,
            refReqId: requestId
        }) : pillLink;
        var onClick = function() {
            if (layoutElement.on_click_event_name) {
                var _item_query;
                var queryWithReplacedSpaces = (_item_query = item.query) === null || _item_query === void 0 ? void 0 : _item_query.replace(/\s/g, "_");
                var token = item.description ? "".concat(queryWithReplacedSpaces, "|").concat(index, "|").concat(item.description) : "".concat(queryWithReplacedSpaces, "|").concat(index);
                onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(layoutElement.on_click_event_name, requestId, token);
            }
        };
        return /*#__PURE__*/ _jsx(React.Fragment, {
            children: /*#__PURE__*/ _jsxs(SearchIconPillStyles.Pill, {
                linkTo: link,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ _jsx(Search, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsxs(SearchIconPillStyles.TextWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                children: item.query
                            }),
                            item.description ? /*#__PURE__*/ _jsx(Typography, {
                                variant: "labelSansRegular",
                                color: Core.text.subdued,
                                children: item.description
                            }) : null
                        ]
                    })
                ]
            })
        }, "".concat(item.query, "_").concat(index));
    };
    var getItems = function() {
        return layoutElement.layout_element_data.map(function(elementData) {
            return elementData.search_query_tile;
        }).filter(isNotUndefined);
    };
    var items = getItems();
    return /*#__PURE__*/ _jsx(FiniteCarouselBase, {
        renderItem: renderItem,
        items: items
    });
};
